module.exports = __webpack_public_path__ + "img/2.2eb86a5e.png";